import {
  Component,
  Input,
  OnInit,
  ViewChildren,
  ElementRef,
  QueryList,
} from "@angular/core";
import * as _ from "lodash";

import { ApirequestService } from "../../../shared/services/apirequest.service";
import { ApirequestdetailService } from "../../../shared/services/apirequestdetail.service";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-intervention-filters",
  templateUrl: "./intervention-filters.component.html",
  styleUrls: ["../../measures/measures.component.scss"],
})
export class InterventionFiltersComponent implements OnInit {
  @Input() pagefilters: any;
  @Input() isOnSidebar: boolean = true;
  @ViewChildren("chkboxes") chkboxes: QueryList<ElementRef>;

  interventionTypeFiltersList = [];
  interventionTypesFilters = [];
  deliveryModeFiltersList = [];
  deliveryModeFilters = [];
  settingsFiltersList = [];
  settingFilters = [];
  sessionDurationFiltersList = [];
  sessionDurationFilters = [];
  totalDurationFiltersList = [];
  totalDurationFilters = [];
  frequencyOfSessionsFiltersList = [];
  frequencyOfSessionsFilters = [];
  targetMechanismFiltersList = [];
  targetMechanismFilters = [];
  targetBehaviorFiltersList = [];
  targetBehaviorFilters = [];

  validityStudiesUploaded = [];
  thefilter;
  btnclicked = false;
  isType = false;
  isHypothesizedDomain = false;
  isStage = false;
  isAdvanced = false;
  isDuration = true;
  isSource = false;
  showType = false;
  showStage = false;
  measure_of_the_day = [];

  selectedType = "intervention_type";
  itemCountKey = "intervention_type";
  showInterventionType = true;

  showDeliveryMode = false;
  showSetting = false;
  showSessionDuration = false;
  showFrequencyOfSessions = false;
  showTargetMechanism = false;

  interventionNumbers: any;
  itemCounts: any;
  menuItems = [
    {
      label: "Intervention Type",
      tooltip: "Broad thematic category of intervention",
      stateKey: "showInterventionType",
      clickHandler: () =>
        this.toggleMenu("showInterventionType", "intervention_type", ""),
      type: "intervention_type",
      filterList: "interventionTypeFiltersList",
      filter: "interventionTypesFilters",
      url: "interventions/type/",
    },
    {
      label: "Delivery Mode",
      tooltip: "The means through which the intervention is deployed",
      stateKey: "showDeliveryMode",
      clickHandler: () =>
        this.toggleMenu("showDeliveryMode", "delivery_mode", ""),
      type: "delivery_mode",
      filterList: "deliveryModeFiltersList",
      filter: "deliveryModeFilters",
      url: "interventions/delivery-mode/",
    },
    {
      label: "Setting",
      tooltip: "The typical place for which the intervention is adapted",
      stateKey: "showSetting",
      clickHandler: () => this.toggleMenu("showSetting", "setting", ""),
      type: "setting",
      filterList: "settingsFiltersList",
      filter: "settingsFilters",
      url: "interventions/settings/",
    },
    {
      label: "Session Duration",
      tooltip:
        "How long, on average, a typical intervention session requires to be administered",
      stateKey: "showSessionDuration",
      clickHandler: () =>
        this.toggleMenu("showSessionDuration", "session_duration", ""),
      type: "session_duration",
      filterList: "sessionDurationFiltersList",
      filter: "sessionDurationFilters",
      url: "interventions/session/",
    },
    {
      label: "Total Duration",
      tooltip:
        "For interventions that require multiple sessions, the total time required to administer all intervention sessions",
      stateKey: "showTotalDuration",
      clickHandler: () =>
        this.toggleMenu("showTotalDuration", "total_duration", ""),
      type: "total_duration",
      filterList: "totalDurationFiltersList",
      filter: "totalDurationFilters",
      url: "interventions/duration/",
    },
    {
      label: "Frequency of Sessions",
      tooltip:
        "For interventions that require multiple sessions, the typical time interval between sessions",
      stateKey: "showFrequencyOfSessions",
      clickHandler: () =>
        this.toggleMenu("showFrequencyOfSessions", "session_frequency", ""),
      type: "session_frequency",
      filterList: "frequencyOfSessionsFiltersList",
      filter: "frequencyOfSessionsDurationFilters",
      url: "interventions/session-frequency/",
    },
    {
      label: "Target Mechanism",
      tooltip:
        "The thematic domain of the mechanism or process that is targeted by the intervention; this mechanism or process may be the means through which the intervention impacts behavior",
      stateKey: "showTargetMechanism",
      clickHandler: () =>
        this.toggleMenu("showTargetMechanism", "target_mechanism", ""),
      type: "target_mechanism",
      filterList: "targetMechanismFiltersList",
      filter: "targetMechanismFilters",
      url: "interventions/target-mechanism/",
    },
    {
      label: "Target Behavior",
      tooltip: "The behavior targeted by the intervention",
      stateKey: "showTargetBehavior",
      clickHandler: () =>
        this.toggleMenu(
          "showTargetBehavior",
          "target_behavior",
          "target_behavior"
        ),
      type: "target_behavior",
      filterList: "targetBehaviorFiltersList",
      filter: "targetBehaviorFilters",
      url: "interventions/target-behaviour/",
    },
  ];

  constructor(
    private apirequestService: ApirequestService,
    private apirequestdetailService: ApirequestdetailService
  ) {}

  activeDropdown: string | null = null;
  isMobile = false;

  ngOnInit() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile.bind(this));
    var params = new HttpParams();
    this.apirequestService
      .get("interventions/intervention-of-the-day/", params)
      .subscribe(
        (res) => {
          this.measure_of_the_day = res.results;
        },
        (error) => {
          console.log(error);
        }
      );

    this.apirequestService.get("interventions/intervention-numbers/").subscribe(
      (res) => {
        this.interventionNumbers = res.measure_source;
        this.itemCounts = res;
      },
      (error) => {
        console.log(error);
      }
    );

    this.loadFilters();
  }

  loadFilters() {
    this.menuItems.forEach((item) => {
      this.apirequestService.get(item.url).subscribe(
        (res) => {
          this[item.filterList] = res.results.reverse();
          this[item.filter] = [];
          _.each(this[item.filterList], (value) => {
            if (this.pagefilters[item.type].includes(value.id)) {
              this[item.filter].push(value.id);
            }
          });
        },
        (error) => {
          console.log(error);
        }
      );
    });
  }

  // _.remove(v, function(n){ return n!=8;});
  arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  }

  toggleEditable(event, type, val) {
    this.menuItems.forEach((item) => {
      if (item.type === type) {
        const filterList = this[item.filterList];
        const filters = this[item.filter];
        if (event.target.checked === true) {
          if (val === "All") {
            filterList.forEach((listItem) => filters.push(listItem.id));
          } else {
            filters.push(val);
          }
        } else if (event.target.checked === false) {
          if (val === "All") {
            this[item.filter] = [];
          } else {
            this[item.filter] = this.arrayRemove(filters, val);
          }
        }
      }
    });

    this.thefilter = {};
    this.menuItems.forEach((item) => {
      this.thefilter[item.type] = this[item.filter].join(",") || "All";
    });

    this.apirequestdetailService.setFilteredData(this.thefilter);
  }

  uncheckAllFilters(): void {
    this.chkboxes.forEach((x) => (x.nativeElement.checked = false));
    this.menuItems.forEach((item) => {
      this.thefilter[item.type] = "All";
    });

    this.apirequestdetailService.setFilteredData(this.thefilter);
  }

  shouldShowFilters(): boolean {
    return this.menuItems.some((item) => this[item.stateKey]);
  }
  getCurrentFiltersList() {
    const activeItem = this.menuItems.find((item) => this[item.stateKey]);
    if (!activeItem) return [];
    const filters = this[activeItem.filterList] || [];
    // if (activeItem.stateKey === "showInterventionType") {
    //   return [...filters].reverse(); // Create a copy and reverse it
    // }
    console.log("filters", filters);
    return filters;
  }

  toggleMenu(selectedMenu: string, type: string, count: string) {
    this.menuItems.forEach((item) => {
      this[item.stateKey] = false;
    });
    this.selectedType = type;
    if (count == "") {
      count = type;
    }
    this.itemCountKey = count;
    this[selectedMenu] = !this[selectedMenu];
    this.activeDropdown = this.activeDropdown === selectedMenu ? null : selectedMenu;
  }

  getFirstHalfFilters() {
    const filtersList = this.getCurrentFiltersList();
    console.log("filtersList", filtersList);
    return filtersList.slice(0, 13);
  }

  getSecondHalfFilters() {
    const filtersList = this.getCurrentFiltersList();
    return filtersList.slice(13);
  }

  isActive(stateKey: string): boolean {
    return this[stateKey];
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 868; // Adjust breakpoint as needed
  }
}
